<!-- AssetMaintenanceRightSidebar -->
<template>
  <!-- <Sidebar :visible="trigger" @update:visible="closedetailsrightsidebar" :style="{ width: sidebarwidth }"
    position="right"> -->
  <Sidebar
    v-model:visible="trigger"
    :style="{ width: sidebarwidth }"
    position="right"
  >
    <template #header>
      <div class="d-flex align-items-center w-100">
        <h6 class="w-100 mb-0">
          {{
            sidebarheading == "View"
              ? t("assetManagement.maintenancedetails.sidebar.view")
              : sidebarheading == "StartAdhoc"
              ? t("assetManagement.maintenancedetails.sidebar.startadhoc")
              : sidebarheading == "Assign"
              ? t("assetManagement.maintenancedetails.sidebar.assign")
              : sidebarheading == "Escalate"
              ? t("assetManagement.maintenancedetails.sidebar.escalate")
              : sidebarheading == "Schedule"
              ? t("assetManagement.maintenancedetails.sidebar.schedule")
              : sidebarheading == "PerformMaintenance"
              ? t(
                  "assetManagement.maintenancedetails.sidebar.performmaintenance"
                )
              : ""
          }}
        </h6>
        <div>
          <i class="pi pi-times" @click="closedetailsrightsidebar()"></i>
        </div>
      </div>
    </template>
    <div class="sidebar-container" :class="{ extended: isExtended }">
      <!-- Main sidebar content -->
      <div
        class="sidebar-content main-content"
        :class="{ extended: isExtended }"
      >
        <!-- Maintenance Scheduling Form for Schedule -->
        <b-container>
          <div v-if="sidebarheading == 'Schedule'">
            <b-form @submit.prevent="saveMaintenanceSchedule">
              <b-row>
                <b-col lg="12" md="12" sm="12" cols="12">
                  <div class="field">
                    <label>{{
                      t("assetManagement.assetassign.assetId")
                    }}</label>
                    <!-- {{assetList}} -->
                    <AutoCompleteCustom
                      :rules="{ required: true }"
                      :required-icon="true"
                      :id="t('assetManagement.assetassign.assetId')"
                      v-model="scheduleForm.assetName"
                      :items="assetList"
                      @input="LoadAsset(scheduleForm.assetName, '')"
                      :disabled="AssetIdDisable"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDatepicker
                      v-model="scheduleForm.lastMaintenance"
                      :label="
                        t('assetManagement.maintenancedetails.lastMaintenance')
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="lastMaintenance"
                      name="lastMaintenance"
                    />
                  </div>
                </b-col>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDatepicker
                      v-model="scheduleForm.nextMaintenanceDate"
                      :label="
                        t('assetManagement.maintenancedetails.nextMaintenance')
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="nextMaintenance"
                      name="nextMaintenance"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDropDown
                      v-model="scheduleForm.maintenanceType"
                      :items="maintenanceTypeList"
                      :label="
                        t('assetManagement.maintenancedetails.maintenanceType')
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="MaintenanceType"
                      name="MaintenanceType"
                    />
                  </div>
                </b-col>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDropDown
                      v-model="scheduleForm.performedBy"
                      :items="technicianList"
                      :label="
                        t('assetManagement.maintenancedetails.technician')
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="TechnicianId"
                      name="TechnicianId"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDatepicker
                      v-model="scheduleForm.scheduledDate"
                      :label="
                        t('assetManagement.maintenancedetails.scheduledDate')
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="ScheduledDate"
                      name="ScheduledDate"
                    />
                  </div>
                </b-col>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <TextField
                      v-model="scheduleForm.cost"
                      type="number"
                      :label="
                        t('assetManagement.maintenancedetails.estimatedCost')
                      "
                      id="EstimatedCost"
                      name="EstimatedCost"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="12" md="12" sm="12" cols="12">
                  <div class="field">
                    <Textarea
                      v-model="scheduleForm.notes"
                      :label="t('assetManagement.maintenancedetails.notes')"
                      id="Notes"
                      name="Notes"
                      :rows="3"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <div class="d-flex flex-row-reverse mt-4">
                  <Footer
                    @cancel="closedetailsrightsidebar"
                    :label="
                      t('assetManagement.maintenancedetails.saveSchedule')
                    "
                    :cancelhide="false"
                    :loading="scheduleLoading"
                  />
                </div>
              </b-row>
            </b-form>
          </div>

          <!-- Assign Technician Form for StartAdhoc -->
          <div v-if="sidebarheading == 'StartAdhoc'">
            <b-form @submit.prevent="saveAdhoc">
              <b-row>
                <b-col lg="12" md="12" sm="12" cols="12">
                  <div class="field">
                    <label>{{
                      t("assetManagement.maintenancedetails.StartAdhoc.assetId")
                    }}</label>
                    <AutoCompleteCustom
                      :rules="{ required: true }"
                      :required-icon="true"
                      :id="
                        t(
                          'assetManagement.maintenancedetails.StartAdhoc.assetId'
                        )
                      "
                      v-model="adhocForm.assetName"
                      :items="assetList"
                      @input="LoadAsset(adhocForm.assetName, '')"
                      @item-select="assetNameAssign"
                      :disabled="AssetIdDisable"
                    />
                  </div>
                </b-col>
              </b-row>

              <!-- issue description -->
              <b-row>
                <b-col lg="12" md="12" sm="12" cols="12">
                  <div class="field">
                    <Textarea
                      v-model="adhocForm.notes"
                      :label="
                        t(
                          'assetManagement.maintenancedetails.StartAdhoc.issueDescription'
                        )
                      "
                      id="IssueDescription"
                      name="Issue Description"
                      :rows="3"
                    />
                  </div>
                </b-col>
              </b-row>

              <!-- priority and requested by  -->
              <b-row>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDropDown
                      v-model="adhocForm.priority"
                      :items="priorityList"
                      :label="
                        t(
                          'assetManagement.maintenancedetails.StartAdhoc.Priority'
                        )
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="AdhocPriority"
                      name="Priority"
                    />
                  </div>
                </b-col>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDropDown
                      v-model="adhocForm.maintenanceType"
                      :items="maintenanceTypeList"
                      :label="
                        t(
                          'assetManagement.maintenancedetails.StartAdhoc.maintenancetype'
                        )
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="MaintenanceType"
                      name="MaintenanceType"
                    />
                  </div>
                </b-col>
              </b-row>
              <!-- preferred date and assign technician -->
              <b-row>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDatepicker
                      v-model="adhocForm.scheduledDate"
                      :label="
                        t(
                          'assetManagement.maintenancedetails.StartAdhoc.prefferedDate'
                        )
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="prefferedDate"
                      name="Preffered Date"
                    />
                  </div>
                </b-col>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDropDown
                      v-model="adhocForm.performedBy"
                      :items="technicianList"
                      :label="
                        t(
                          'assetManagement.maintenancedetails.StartAdhoc.technician'
                        )
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="assignTechnician"
                      name="Assign Technician"
                    />
                  </div>
                </b-col>
              </b-row>
              <!-- estimated cost -->
              <b-row>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <TextField
                      v-model="adhocForm.cost"
                      type="number"
                      :label="
                        t('assetManagement.maintenancedetails.StartAdhoc.cost')
                      "
                      id="EstimatedCost"
                      name="Estimated Cost"
                    />
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <div class="d-flex flex-row-reverse mt-4">
                  <Footer
                    @cancel="closedetailsrightsidebar"
                    :label="
                      t('assetManagement.maintenancedetails.saveSchedule')
                    "
                    :cancelhide="false"
                    :loading="scheduleLoading"
                  />
                </div>
              </b-row>
            </b-form>
          </div>

          <!-- Maintenance Details View for View -->
          <div v-else-if="sidebarheading == 'View'">
            <div
              v-if="
                assetListMaintenanceList.MaintenanceDetails ||
                assetListMaintenanceList.RecentMaintenanceLog
              "
            >
              <!-- Asset Title -->
              <!-- <div class="mb-3"> -->
              <!-- {{ assetListMaintenanceList.MaintenanceDetails[0].AssetName }} -->
              <!-- <h5 class="mb-2">
            Maintenance Details: {{ assetListMaintenanceList.MaintenanceDetails[0].AssetID || "" }}
          </h5> -->
              <!-- </div> -->

              <!-- Asset Information -->
              <b-row class="">
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="d-flex align-items-center gap-3"
                >
                  <span class="light-txt"
                    >{{
                      t("assetManagement.maintenancedetails.details.asset")
                    }}:</span
                  >
                  <span class="sidbarContent-val">{{
                    assetListMaintenanceList.MaintenanceDetails[0][
                      "AssetName"
                    ] || ""
                  }}</span>
                </b-col>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="d-flex align-items-center gap-3"
                >
                  <span class="light-txt"
                    >{{
                      t(
                        "assetManagement.maintenancedetails.details.maintenancetype"
                      )
                    }}:</span
                  >
                  <span class="sidbarContent-val">{{
                    assetListMaintenanceList.MaintenanceDetails[0][
                      "MaintenanceTypeName"
                    ] || ""
                  }}</span>
                </b-col>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="d-flex align-items-center gap-3"
                >
                  <span class="light-txt"
                    >{{
                      t(
                        "assetManagement.maintenancedetails.details.lastmaintenance"
                      )
                    }}:</span
                  >
                  <span class="sidbarContent-val">{{
                    assetListMaintenanceList.MaintenanceDetails[0][
                      "lastMaintenance"
                    ] || ""
                  }}</span>
                </b-col>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="d-flex align-items-center gap-3"
                >
                  <span class="light-txt"
                    >{{
                      t(
                        "assetManagement.maintenancedetails.details.nextmaintenance"
                      )
                    }}:</span
                  >
                  <span class="sidbarContent-val">{{
                    assetListMaintenanceList.MaintenanceDetails[0][
                      "NextMaintenanceDate"
                    ] || ""
                  }}</span>
                </b-col>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="d-flex align-items-center gap-3"
                >
                  <span class="light-txt"
                    >{{
                      t(
                        "assetManagement.maintenancedetails.details.warrantystatus"
                      )
                    }}:</span
                  >
                  <span class="sidbarContent-val">{{
                    assetListMaintenanceList.MaintenanceDetails[0][
                      "WarrantyStatus"
                    ] || ""
                  }}</span>
                </b-col>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="d-flex align-items-center gap-3"
                >
                  <span class="light-txt"
                    >{{
                      t(
                        "assetManagement.maintenancedetails.details.currentstatus"
                      )
                    }}:</span
                  >
                  <span class="sidbarContent-val">{{
                    assetListMaintenanceList.MaintenanceDetails[0][
                      "currentStatus"
                    ] || ""
                  }}</span>
                </b-col>
              </b-row>

              <hr class="my-3" />

              <!-- Recent Maintenance Log -->
              <div class="mb-3">
                <h6 class="mb-2">Recent Maintenance Log:</h6>
              </div>

              <div
                class="maintenance-log-card p-3 mb-3"
                style="
                  background-color: #f8f9fa;
                  border-radius: 8px;
                  border: 1px solid #e9ecef;
                "
              >
                <b-row class="px-2">
                  <b-col
                    lg="12"
                    md="12"
                    sm="12"
                    cols="12"
                    class="d-flex align-items-center gap-3"
                  >
                    <span class="light-txt"
                      >{{
                        t("assetManagement.maintenancedetails.details.date")
                      }}:</span
                    >
                    <span class="sidbarContent-val">{{
                      assetListMaintenanceList.RecentMaintenanceLog[0][
                        "Date"
                      ] || ""
                    }}</span>
                  </b-col>
                  <b-col
                    lg="12"
                    md="12"
                    sm="12"
                    cols="12"
                    class="d-flex align-items-center gap-3"
                  >
                    <span class="light-txt"
                      >{{
                        t(
                          "assetManagement.maintenancedetails.details.technician"
                        )
                      }}:</span
                    >
                    <span class="sidbarContent-val">{{
                      assetListMaintenanceList.RecentMaintenanceLog[0][
                        "TechnicianName"
                      ] || ""
                    }}</span>
                  </b-col>
                  <b-col
                    lg="12"
                    md="12"
                    sm="12"
                    cols="12"
                    class="d-flex align-items-center gap-3"
                  >
                    <span class="light-txt"
                      >{{
                        t("assetManagement.maintenancedetails.details.type")
                      }}:</span
                    >
                    <span class="sidbarContent-val">{{
                      assetListMaintenanceList.MaintenanceDetails[0][
                        "MaintenanceTypeName"
                      ] || ""
                    }}</span>
                  </b-col>
                  <b-col
                    lg="12"
                    md="12"
                    sm="12"
                    cols="12"
                    class="d-flex align-items-center gap-3"
                  >
                    <span class="light-txt"
                      >{{
                        t("assetManagement.maintenancedetails.details.cost")
                      }}:</span
                    >
                    <span class="sidbarContent-val">{{
                      assetListMaintenanceList.RecentMaintenanceLog[0][
                        "Cost"
                      ] || ""
                    }}</span>
                  </b-col>
                  <b-col
                    lg="12"
                    md="12"
                    sm="12"
                    cols="12"
                    class="d-flex align-items-center gap-3"
                  >
                    <span class="light-txt"
                      >{{
                        t(
                          "assetManagement.maintenancedetails.details.workperformed"
                        )
                      }}:</span
                    >
                    <span class="sidbarContent-val">{{
                      assetListMaintenanceList.RecentMaintenanceLog[0][
                        "WorkPerformed"
                      ] || ""
                    }}</span>
                  </b-col>
                  <b-col
                    lg="12"
                    md="12"
                    sm="12"
                    cols="12"
                    class="d-flex align-items-center gap-3"
                  >
                    <span class="light-txt"
                      >{{
                        t("assetManagement.maintenancedetails.details.status")
                      }}:</span
                    >
                    <span class="sidbarContent-val">{{
                      assetListMaintenanceList.RecentMaintenanceLog[0][
                        "MaintenanceStatus"
                      ] == 0
                        ? "Scheduled"
                        : assetListMaintenanceList.RecentMaintenanceLog[0][
                            "MaintenanceStatus"
                          ] == 1
                        ? "Assigned"
                        : assetListMaintenanceList.RecentMaintenanceLog[0][
                            "MaintenanceStatus"
                          ] == 2
                        ? "Completed"
                        : ""
                    }}</span>
                  </b-col>
                </b-row>
              </div>
              <div class="mb-3">
                <h6 class="mb-2">Assigned Log:</h6>
              </div>
              <div>
                <SkeletonTableLoader
                  :columns="Historyheaders"
                  :loading="loading"
                />
                <div v-if="!loading">
                  <!-- {{ assetMaintenanceHistory }} -->
                  <NormalTableview
                    v-model:value="assetMaintenanceHistory"
                    :paginator="true"
                    class="p-datatable-gridlines"
                    :rows="10"
                    :rowHover="true"
                    :loading="loading"
                    responsiveLayout="scroll"
                    :columns="Historyheaders"
                    dataKey="RowNumber"
                    :selectionMode="false"
                    :seriaNlumber="true"
                  >
                    <template v-slot:TechnicianName="{ data }">
                      <div>
                        <span>
                          {{ data.TechnicianName ? data.TechnicianName : "-" }}
                        </span>
                        <span
                          v-if="data.IsActive == 1"
                          style="color: green; font-size: 0.85em"
                        >
                          (currently active)
                        </span>
                      </div>
                    </template>

                    <template v-slot:Status="{ data }">
                      <OrangeStatus
                        name="Closed Escalation"
                        v-if="data.CurrentStatus == 0"
                      />
                      <GreenStatus
                        name="Assigned"
                        v-if="data.CurrentStatus == 1"
                      />
                      <RedStatus
                        name="Escalation"
                        v-if="data.CurrentStatus == 2"
                      />
                    </template>
                  </NormalTableview>
                </div>
              </div>

              <!-- Action Buttons -->
              <!-- <div class="action-buttons-grid">
          <b-row class="px-3">
            <b-col sm="12" md="6" lg="6" xl="6" class="mb-2">
              <button class="btn btn-outline-primary btn-sm w-100">
                View Full History
              </button>
            </b-col>
            <b-col sm="12" md="6" lg="6" xl="6" class="mb-2">
              <button class="btn btn-primary btn-sm w-100">
                Schedule Next
              </button>
            </b-col>
          </b-row>
          <b-row class="px-3">
            <b-col sm="12" md="6" lg="6" xl="6" class="mb-2">
              <button class="btn btn-warning btn-sm w-100">
                Start Adhoc
              </button>
            </b-col>
            <b-col sm="12" md="6" lg="6" xl="6" class="mb-2">
              <button class="btn btn-info btn-sm w-100">
                Update Asset Info
              </button>
            </b-col>
          </b-row>
          <b-row class="px-3">
            <b-col sm="12" md="12" lg="12" xl="12" class="mb-2">
              <button class="btn btn-secondary btn-sm w-100">
                View/Update Warranty
              </button>
            </b-col>
          </b-row>
        </div> -->
            </div>
          </div>

          <!-- Assign Technician Form for Assign -->
          <div v-else-if="sidebarheading == 'Assign'">
            <b-form @submit.prevent="assignTechnician">
              <b-row>
                <b-col lg="12" md="12" sm="12" cols="12">
                  <div class="field">
                    <label>{{
                      t("assetManagement.maintenancedetails.assetName")
                    }}</label>
                    <AutoCompleteCustom
                      :rules="{ required: true }"
                      :required-icon="true"
                      :id="t('assetManagement.assetassign.assetName')"
                      v-model="assignForm.assetName"
                      :items="assetList"
                      @input="LoadAsset(assignForm.assetName, '')"
                      :disabled="AssetName"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDropDown
                      v-model="assignForm.maintenanceType"
                      :items="maintenanceTypeList"
                      :label="
                        t('assetManagement.maintenancedetails.maintenanceType')
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="AssignMaintenanceType"
                      name="AssignMaintenanceType"
                    />
                  </div>
                </b-col>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDatepicker
                      v-model="assignForm.scheduledDate"
                      :label="
                        t('assetManagement.maintenancedetails.scheduledDate')
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="AssignScheduledDate"
                      name="AssignScheduledDate"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDropDown
                      v-model="assignForm.performedBy"
                      :items="technicianList"
                      :label="
                        t('assetManagement.maintenancedetails.technician')
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="AssignTechnicianId"
                      name="AssignTechnicianId"
                    />
                  </div>
                </b-col>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <TextField
                      v-model="assignForm.estimatedDuration"
                      type="text"
                      :label="
                        t(
                          'assetManagement.maintenancedetails.estimatedDuration'
                        )
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="EstimatedDuration"
                      name="EstimatedDuration"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDropDown
                      v-model="assignForm.priority"
                      :items="priorityList"
                      :label="t('assetManagement.maintenancedetails.priority')"
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="Priority"
                      name="Priority"
                    />
                  </div>
                </b-col>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <Textarea
                      v-model="assignForm.assignNotes"
                      :label="t('assetManagement.maintenancedetails.notes')"
                      id="AssignNotes"
                      name="AssignNotes"
                      :rows="3"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <div class="d-flex flex-row-reverse mt-4">
                  <Footer
                    @cancel="closedetailsrightsidebar"
                    :label="
                      t('assetManagement.maintenancedetails.assignTechnician')
                    "
                    :cancelhide="false"
                    :loading="assignLoading"
                  />
                </div>
              </b-row>
            </b-form>
          </div>
          <!-- Assign Technician Form for PerformMaintenance -->
          <div v-else-if="sidebarheading == 'PerformMaintenance'">
            <b-row
              class="mb-3"
              v-if="
                assetListMaintenanceList.MaintenanceDetails ||
                assetListMaintenanceList.RecentMaintenanceLog
              "
            >
              <b-col
                lg="12"
                md="12"
                sm="12"
                cols="12"
                class="d-flex align-items-center gap-3"
              >
                <span class="light-txt">Maintenance ID:</span>
                <span class="sidbarContent-val">{{
                  performMaintenanceForm.assetName
                }}</span>
              </b-col>
              <b-col
                lg="12"
                md="12"
                sm="12"
                cols="12"
                class="d-flex align-items-center gap-3"
              >
                <span class="light-txt">Type:</span>
                <span class="sidbarContent-val">{{
                  assetListMaintenanceList.MaintenanceDetails[0][
                    "MaintenanceTypeName"
                  ]
                }}</span>
              </b-col>
              <b-col
                lg="12"
                md="12"
                sm="12"
                cols="12"
                class="d-flex align-items-center gap-3"
              >
                <span class="light-txt">Scheduled Date:</span>
                <span class="sidbarContent-val">{{
                  performMaintenanceForm.scheduledDate
                }}</span>
              </b-col>
              <b-col
                lg="12"
                md="12"
                sm="12"
                cols="12"
                class="d-flex align-items-center gap-3"
              >
                <span class="light-txt">Technician:</span>
                <span class="sidbarContent-val">{{
                  assetListMaintenanceList.RecentMaintenanceLog[0][
                    "TechnicianName"
                  ]
                }}</span>
              </b-col>
            </b-row>
            <b-form @submit.prevent="performMaintenance">
              <b-row>
                <b-col lg="12" md="12" sm="12" cols="12">
                  <label class="mb-2">{{
                    t("assetManagement.maintenancedetails.checklist")
                  }}</label>
                  <div class="field checklistcheckbox-list">
                    <div
                      class="d-flex align-items-center mb-1 checklistcheckbox"
                      v-for="(items, index) in checklistArray"
                      :key="index"
                    >
                      <Checkbox
                        v-model="performMaintenanceForm.checkList"
                        :inputId="'check_' + index"
                        :binary="false"
                        :name="items.Name"
                        :value="items.Id"
                      />
                      <label :for="'check_' + index" class="ml-2"
                        >{{ items.Name }}
                      </label>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="4" md="4" sm="5" cols="12">
                  <div class="field">
                    <label>{{
                      t("assetManagement.maintenancedetails.addspares")
                    }}</label>
                    <AutoCompleteCustom
                      :rules="{ required: true }"
                      :required-icon="true"
                      :id="t('assetManagement.assetassign.addspares')"
                      v-model="performMaintenanceForm.spares"
                      :items="assetList"
                      @input="LoadAsset(performMaintenanceForm.spares, '')"
                      :disabled="AssetName"
                      @item-select="addSpares"
                    />
                    <!-- :items="assetItemList" @input="LoadAssetItem(performMaintenanceForm.spares)" -->
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="assetSparesList.length > 0">
                <b-col>
                  <Tableview
                    :value="assetSparesList"
                    :paginator="false"
                    class="p-datatable-gridlines commonstatusclass"
                    :rows="10"
                    :rowHover="true"
                    filterDisplay="menu"
                    responsiveLayout="scroll"
                    :columns="sparesheaders"
                    :globalFilterFields="globalSparesFilterFields"
                    :filters="sparesfilters"
                    @ShowRows=""
                    :exceldownload="true"
                    :filterbtn="true"
                    :statusFilterBtn="true"
                    :searchbox="false"
                  >
                    <template v-slot:action="{ data }">
                      <span>
                        <Button
                          icon="pi pi-trash"
                          class="p-button-rounded editicon p-button-text"
                          @click="removeSpare(index)"
                        />
                      </span>
                    </template>
                  </Tableview>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="4" md="4" sm="5" cols="12">
                  <div class="field">
                    <TextField
                      v-model="performMaintenanceForm.maintenanceCost"
                      type="text"
                      :label="
                        t('assetManagement.maintenancedetails.maintenanceCost')
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="EstimatedDuration"
                      name="EstimatedDuration"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="field">
                    <Textarea
                      v-model="performMaintenanceForm.workPerformed"
                      :label="
                        t('assetManagement.maintenancedetails.workPerformed')
                      "
                      id="workPerformed"
                      name="workPerformed"
                      :rows="3"
                    />
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <div class="field">
                    <Textarea
                      v-model="performMaintenanceForm.performedNotes"
                      :label="
                        t('assetManagement.maintenancedetails.performedNotes')
                      "
                      id="performedNotes"
                      name="performedNotes"
                      :rows="3"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <div class="d-flex flex-row-reverse mt-4">
                  <Footer
                    @cancel="extendSidebar(assetListMaintenanceList)"
                    :label="
                      t(
                        'assetManagement.maintenancedetails.completemaintenance'
                      )
                    "
                    CancelLabel="Request Escalation"
                    :loading="performMaintenanceLoading"
                  />
                </div>
              </b-row>
            </b-form>
          </div>

          <!-- Other sidebar content for different headings -->
          <div v-else>
            <!-- field -->
            <!-- here you content -->
          </div>
        </b-container>
      </div>

      <!-- Extended content area -->
      <div v-if="isExtended" class="extended-content">
        <b-container>
          <div class="extended-header">
            <h6>Extended Information</h6>
            <i class="pi pi-times" @click="collapseSidebar"></i>
          </div>
          <div class="extended-body">
            <b-row v-if="escalationTableList.lenghth > 0">
              <b-col>
                <SkeletonTableLoader
                  :columns="headers"
                  v-if="skeletonloading"
                />
                <Tableview
                  :value="escalationTableList"
                  :paginator="true"
                  class="p-datatable-gridlines commonstatusclass"
                  :rows="10"
                  :rowHover="true"
                  filterDisplay="menu"
                  responsiveLayout="scroll"
                  :columns="headers"
                  @row-click=""
                  :globalFilterFields="globalFilterFields"
                  :filters="filters"
                  @ShowRows=""
                  :exceldownload="true"
                  :filterbtn="true"
                  :statusFilterBtn="true"
                  :searchbox="false"
                  v-else
                >
                  <template v-slot:status="{ data }">
                    <OrangeStatus name="InActive" v-if="data.Status == '0'" />
                    <GreenStatus name="Active" v-if="data.Status == '1'" />
                  </template>
                </Tableview>
              </b-col>
            </b-row>
            <b-row v-if="escalationTableList.lenghth > 0">
              <b-col
                lg="12"
                md="12"
                sm="12"
                cols="12"
                class="d-flex align-items-center gap-3"
              >
                <span class="light-txt"
                  >{{
                    t("assetManagement.maintenancedetails.escalation.asset")
                  }}:</span
                >
                <span class="sidbarContent-val"></span>
              </b-col>

              <b-col
                lg="12"
                md="12"
                sm="12"
                cols="12"
                class="d-flex align-items-center gap-3"
              >
                <span class="light-txt"
                  >{{
                    t(
                      "assetManagement.maintenancedetails.escalation.escalationdate"
                    )
                  }}:</span
                >
                <span class="sidbarContent-val"></span>
              </b-col>
              <b-col
                lg="12"
                md="12"
                sm="12"
                cols="12"
                class="d-flex align-items-center gap-3"
              >
                <span class="light-txt"
                  >{{
                    t(
                      "assetManagement.maintenancedetails.escalation.actiontaken"
                    )
                  }}:</span
                >
                <span class="sidbarContent-val"></span>
              </b-col>
              <b-col
                lg="12"
                md="12"
                sm="12"
                cols="12"
                class="d-flex align-items-center gap-3"
              >
                <span class="light-txt"
                  >{{
                    t("assetManagement.maintenancedetails.escalation.reason")
                  }}:</span
                >
                <span class="sidbarContent-val"></span>
              </b-col>
              <b-col
                lg="12"
                md="12"
                sm="12"
                cols="12"
                class="d-flex align-items-center gap-3"
              >
                <span class="light-txt"
                  >{{
                    t(
                      "assetManagement.maintenancedetails.escalation.assignedto"
                    )
                  }}:</span
                >
                <span class="sidbarContent-val"></span>
              </b-col>
              <b-col
                lg="12"
                md="12"
                sm="12"
                cols="12"
                class="d-flex align-items-center gap-3"
              >
                <span class="light-txt"
                  >{{
                    t("assetManagement.maintenancedetails.escalation.status")
                  }}:</span
                >
                <span class="sidbarContent-val"></span>
              </b-col>
            </b-row>
            <b-form @submit.prevent="escalationSave">
              <b-row>
                <b-col lg="6" md="6" sm="5" cols="12">
                  <div class="field">
                    <TextField
                      v-model="escalationForm.actionTaken"
                      type="text"
                      :label="
                        t(
                          'assetManagement.maintenancedetails.escalation.actiontaken'
                        )
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="actionTaken"
                      name="actionTaken"
                    />
                  </div>
                </b-col>
                <b-col lg="6" md="6" sm="5" cols="12">
                  <div class="field">
                    <CustomDatepicker
                      v-model="escalationForm.escalationDate"
                      :label="
                        t(
                          'assetManagement.maintenancedetails.escalation.escalationdate'
                        )
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="escalationDate"
                      name="escalationDate"
                    />
                  </div>
                </b-col>
                <b-col lg="6" md="6" sm="12" cols="12">
                  <div class="field">
                    <CustomDropDown
                      v-model="escalationForm.reason"
                      :items="reasonList"
                      :label="
                        t(
                          'assetManagement.maintenancedetails.escalation.reason'
                        )
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="reason"
                      name="reason"
                    />
                  </div>
                </b-col>
                <b-col lg="2" md="3" sm="4" cols="12">
                  <div class="field">
                    <label>{{
                      t(
                        "assetManagement.maintenancedetails.escalation.reassign"
                      )
                    }}</label>
                    <InputSwitch v-model="escalationForm.reassign" />
                  </div>
                </b-col>
                <b-col
                  lg="6"
                  md="6"
                  sm="12"
                  cols="12"
                  v-if="escalationForm.reassign"
                >
                  <div class="field">
                    <CustomDropDown
                      v-model="escalationForm.assignedTo"
                      :items="technicianList"
                      :label="
                        t(
                          'assetManagement.maintenancedetails.escalation.assignedto'
                        )
                      "
                      :rules="{ required: true }"
                      :required-icon="true"
                      id="assignedTo"
                      name="assignedTo"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <div class="d-flex flex-row-reverse mt-4">
                  <Footer
                    :label="
                      t('assetManagement.maintenancedetails.assignTechnician')
                    "
                    :cancelhide="false"
                    :loading="performMaintenanceLoading"
                  />
                </div>
              </b-row>
            </b-form>
          </div>
        </b-container>
      </div>
    </div>
  </Sidebar>
  <CreateSuccessully :visible="createpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  <Toast />
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  watch,
  watchEffect,
} from "vue";
import { useI18n } from "vue-i18n";
import TextField from "../../../../../../../components/FormComponents/TextInput.vue";
import CustomDropDown from "../../../../../../../components/FormComponents/Dropdown.vue";
import CustomDatepicker from "../../../../../../../components/FormComponents/DatePicker.vue";
import NormalTableview from "../../../../../../../components/FormComponents/NormalTable.vue";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import Textarea from "../../../../../../../components/FormComponents/TextArea.vue";
import { useRoute } from "vue-router";
import { useForm } from "vee-validate";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import { useToast } from "primevue/usetoast";
import StoreService from "../../../../../../../modules/Inventory/Service/StoreService";
import MaintenanceScheduleMasterServices from "../../../../../Service/AssetManagement/MaintenanceScheduleMasterService";
import AutoCompleteCustom from "../../../../../../../components/FormComponents/AutoComplete.vue";
import AssetMasterService from "../../../../../../../modules/Inventory/Service/AssetManagement/AssetMasterService";
import AssetMaintenanceService from "../../../../../../../modules/Inventory/Service/AssetManagement/AssetMaintenanceService";
import CheckListMasterService from "../../../../../../../modules/Inventory/Service/AssetManagement/CheckListMasterService";
import Sidebar from "primevue/sidebar";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
// import Checkbox from 'primevue/checkbox';
// import Toast from 'primevue/toast';
import moment from "moment";
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../../components/FormComponents/AlreadyExist.vue";
import { log } from "console";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import stockReasonService from "../../../../../../../modules/Inventory/Service/StockReasonService";
import EscalationService from "../../../../../../../modules/Inventory/Service/AssetManagement/EscalationService";
import Itemservice from "../../../../../../../modules/Inventory/Service/ItemMasService";

export default defineComponent({
  props: {
    trigger: {
      type: Boolean,
      default: true,
    },
    sidebarheading: {
      type: String,
      default: "",
    },
    tableId: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
  },
  components: {
    Textarea,
    Footer,
    TextField,
    CustomDropDown,
    CustomDatepicker,
    NormalTableview,
    SkeletonTableLoader,
    AutoCompleteCustom,
    Sidebar,
    Tableview,
    // Checkbox,
    // Toast,
    UpdatedSuccessfully,
    CreateSuccessully,
    AlreadyExist,
  },
  setup(props, { emit }) {
    const showdetailrightsidebar = ref(false);
    const toast = useToast();
    const confirmationmodel = ref(false);
    const route = useRoute();
    const alreadyexistpop = ref(false);
    const updatepop = ref(false);
    const createpop = ref(false);
    const scheduleLoading = ref(false);
    const assignLoading = ref(false);
    const adhocLoading = ref(false);
    const performMaintenanceLoading = ref(false);
    const escalationLoading = ref(false);
    const testdata = ref([]);
    const show = ref();
    const { t } = useI18n();
    const { handleSubmit, resetForm, validate } = useForm();
    const checklistArray = ref([]);
    const assetItemList = ref([]);
    const assetSparesList = ref([]);
    const assetList = ref([]);
    const sidebarwidth = ref("35rem");
    const isExtended = ref(false);
    const skeletonloading = ref(false);
    let SessionUserData = localStorage.getItem("UsersData");
    const escalationTableList = ref([]);
    const loading = ref(false);
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let SessionRolesData = localStorage.getItem("RolesData");
    let roleData;
    if (SessionRolesData !== null) {
      roleData = JSON.parse(SessionRolesData);
    }
    const ParamValues = ref({
      StoreId: Number(route.query.Id ?? 0),
      BranchId: Number(route.query.BranchId ?? 0),
    });
    let scannedItems: any = ref([{}]);
    let selectedProduct: any = ref([]);

    const assetListMaintenanceList = ref([]);
    const maintenanceTypeList = ref([]);
    const reasonList = ref([]);
    const AssetIdDisable = ref(false);
    const AssetName = ref(false);
    const technicianList = ref([]);
    const assetMaintenanceHistory = ref([]);
    // Dropdown options
    const priorityList = ref([
      { name: "Low", value: 1 },
      { name: "Medium", value: 2 },
      { name: "High", value: 3 },
    ]);

    const adhocForm = ref({
      isNew: true,
      isModified: true,
      isDeleted: true,
      isActive: true,
      createdAt: "2025-09-10T14:05:52.985Z",
      modifiedAt: "2025-09-10T14:05:52.985Z",
      modifiedBy: 0,
      createdByName: "",
      modifiedByName: "",
      entityId: 0,
      entityOperationId: 0,
      deptRoleId: 0,
      hospitalId: 0,
      branchId: 0,
      fromStoreBranchId: 0,
      toStoreBranchId: 0,
      isEntitySMS: 0,
      organizationName: "",
      organizationId: 0,
      branchName: "",
      fromStoreBranchName: "",
      toStoreBranchName: "",
      storeName: "",
      fromStoreName: "",
      toStoreName: "",
      supplierName: "",
      rowNumber: 0,
      id: 0,
      taskStatus: 0,
      taskExpiryDate: "2025-09-10T14:05:52.985Z",
      taskName: "",
      taskPriority: 0,
      responseTimeInHours: 0,
      isApprovalRequired: true,
      levelsOfApproval: 0,
      maintenanceID: 0,
      maintenanceType: "",
      maintenanceDate: "2025-09-10T14:05:52.985Z",
      maintenanceDetails: "",
      maintenanceStatus: "0",
      warrantyStatus: "",
      serviceWorkOrder: "",
      updatedAt: "2025-09-10T14:05:52.985Z",
      updatedBy: "",
      nextMaintenanceDate: "2025-09-10T14:05:52.985Z",
      isCorrectiveMaintenance: true,
      suggestedAction: "",
      estimatedDuration: 0,
      scheduledDate: "2025-09-10T14:05:52.985Z",
      assignNotes: "",
      workPerformed: "",
      lastMaintenance: "2025-09-10T14:05:52.985Z",
      currentStatus: "",
      assetID: 0,
      assetName: "",
      notes: "",
      priority: 0,
      createdBy: "",
      performedBy: 0,
      cost: 0,
      status: 0,
    });

    const copyadhocForm = JSON.parse(JSON.stringify(adhocForm.value));

    const scheduleForm = ref({
      isNew: true,
      isModified: true,
      isDeleted: true,
      isActive: true,
      createdAt: "2025-09-10T14:05:52.985Z",
      modifiedAt: "2025-09-10T14:05:52.985Z",
      createdBy: 0,
      modifiedBy: 0,
      createdByName: "",
      modifiedByName: "",
      entityId: 0,
      entityOperationId: 0,
      deptRoleId: 0,
      hospitalId: 0,
      branchId: 0,
      fromStoreBranchId: 0,
      toStoreBranchId: 0,
      isEntitySMS: 0,
      organizationName: "",
      organizationId: 0,
      branchName: "",
      fromStoreBranchName: "",
      toStoreBranchName: "",
      storeName: "",
      fromStoreName: "",
      toStoreName: "",
      supplierName: "",
      rowNumber: 0,
      id: 0,
      taskStatus: 0,
      taskExpiryDate: "2025-09-10T14:05:52.985Z",
      taskName: "",
      taskPriority: 0,
      responseTimeInHours: 0,
      isApprovalRequired: true,
      levelsOfApproval: 0,
      maintenanceID: 0,
      assetID: 0,
      maintenanceType: "",
      maintenanceDate: "2025-09-10T14:05:52.985Z",
      maintenanceDetails: "",
      maintenanceStatus: "",
      performedBy: "",
      cost: 0,
      warrantyStatus: "",
      serviceWorkOrder: "",
      notes: "",
      updatedAt: "2025-09-10T14:05:52.985Z",
      updatedBy: "",
      nextMaintenanceDate: "2025-09-10T14:05:52.985Z",
      isCorrectiveMaintenance: true,
      suggestedAction: "",
      estimatedDuration: 0,
      assetName: "",
      scheduledDate: "2025-09-10T14:05:52.985Z",
      priority: 0,
      assignNotes: "",
      workPerformed: "",
      lastMaintenance: "2025-09-10T14:05:52.985Z",
      currentStatus: "",
    });
    const copyscheduleForm = JSON.parse(JSON.stringify(scheduleForm.value));

    const assignForm = ref({
      isNew: true,
      isModified: true,
      isDeleted: true,
      isActive: true,
      createdAt: "2025-09-10T14:05:52.985Z",
      modifiedAt: "2025-09-10T14:05:52.985Z",
      createdBy: 0,
      modifiedBy: 0,
      createdByName: "",
      modifiedByName: "",
      entityId: 0,
      entityOperationId: 0,
      deptRoleId: 0,
      hospitalId: 0,
      branchId: 0,
      fromStoreBranchId: 0,
      toStoreBranchId: 0,
      isEntitySMS: 0,
      organizationName: "",
      organizationId: 0,
      branchName: "",
      fromStoreBranchName: "",
      toStoreBranchName: "",
      storeName: "",
      fromStoreName: "",
      toStoreName: "",
      supplierName: "",
      rowNumber: 0,
      id: 0,
      taskStatus: 0,
      taskExpiryDate: "2025-09-10T14:05:52.985Z",
      taskName: "",
      taskPriority: 0,
      responseTimeInHours: 0,
      isApprovalRequired: true,
      levelsOfApproval: 0,
      maintenanceID: 0,
      assetID: 0,
      maintenanceType: "",
      maintenanceDate: "2025-09-10T14:05:52.985Z",
      maintenanceDetails: "",
      maintenanceStatus: "",
      performedBy: "",
      cost: 0,
      warrantyStatus: "",
      serviceWorkOrder: "",
      notes: "",
      updatedAt: "2025-09-10T14:05:52.985Z",
      updatedBy: "",
      nextMaintenanceDate: "2025-09-10T14:05:52.985Z",
      isCorrectiveMaintenance: true,
      suggestedAction: "",
      estimatedDuration: 0,
      assetName: "",
      scheduledDate: "2025-09-10T14:05:52.985Z",
      priority: 0,
      assignNotes: "",
      workPerformed: "",
      lastMaintenance: "2025-09-10T14:05:52.985Z",
      currentStatus: "",
    });
    const copyassignForm = JSON.parse(JSON.stringify(assignForm.value));

    const performMaintenanceForm = ref({
      isNew: true,
      isModified: true,
      isDeleted: true,
      isActive: true,
      createdAt: "2025-09-10T14:05:52.985Z",
      modifiedAt: "2025-09-10T14:05:52.985Z",
      createdBy: 0,
      modifiedBy: 0,
      createdByName: "",
      modifiedByName: "",
      entityId: 0,
      entityOperationId: 0,
      deptRoleId: 0,
      hospitalId: 0,
      branchId: 0,
      fromStoreBranchId: 0,
      toStoreBranchId: 0,
      isEntitySMS: 0,
      organizationName: "",
      organizationId: 0,
      branchName: "",
      fromStoreBranchName: "",
      toStoreBranchName: "",
      storeName: "",
      fromStoreName: "",
      toStoreName: "",
      supplierName: "",
      rowNumber: 0,
      id: 0,
      taskStatus: 0,
      taskExpiryDate: "2025-09-10T14:05:52.985Z",
      taskName: "",
      taskPriority: 0,
      responseTimeInHours: 0,
      isApprovalRequired: true,
      levelsOfApproval: 0,
      maintenanceID: 0,
      assetID: 0,
      maintenanceType: "",
      maintenanceDate: "2025-09-10T14:05:52.985Z",
      maintenanceDetails: "",
      maintenanceStatus: "",
      performedBy: "",
      cost: 0,
      warrantyStatus: "",
      serviceWorkOrder: "",
      notes: "",
      updatedAt: "2025-09-10T14:05:52.985Z",
      updatedBy: "",
      nextMaintenanceDate: "2025-09-10T14:05:52.985Z",
      isCorrectiveMaintenance: true,
      suggestedAction: "",
      estimatedDuration: 0,
      assetName: "",
      scheduledDate: "2025-09-10T14:05:52.985Z",
      priority: 0,
      assignNotes: "",
      workPerformed: "",
      lastMaintenance: "2025-09-10T14:05:52.985Z",
      currentStatus: "",
      maintenanceCost: 0,
      performedNotes: "",
      checkList: "",
      spares: "",
    });
    const copyperformMaintenanceForm = JSON.parse(
      JSON.stringify(performMaintenanceForm.value)
    );
    const checkListMappingForm = ref({
      isNew: true,
      isModified: true,
      isDeleted: true,
      isActive: true,
      createdAt: "2025-09-10T14:05:52.985Z",
      modifiedAt: "2025-09-10T14:05:52.985Z",
      createdBy: 0,
      modifiedBy: 0,
      createdByName: "",
      modifiedByName: "",
      entityId: 0,
      entityOperationId: 0,
      deptRoleId: 0,
      hospitalId: 0,
      branchId: 0,
      fromStoreBranchId: 0,
      toStoreBranchId: 0,
      isEntitySMS: 0,
      organizationName: "",
      organizationId: 0,
      branchName: "",
      fromStoreBranchName: "",
      toStoreBranchName: "",
      storeName: "",
      fromStoreName: "",
      toStoreName: "",
      supplierName: "",
      rowNumber: 0,
      id: 0,
      checkListId: 0,
      maintanenceId: 0,
      updatedAt: "2025-09-10T14:05:52.985Z",
      updatedBy: "",
    });
    const copycheckListMappingForm = JSON.parse(
      JSON.stringify(checkListMappingForm.value)
    );
    const sparesForm = ref({
      isNew: true,
      isModified: true,
      isDeleted: true,
      isActive: true,
      createdAt: "2025-09-10T14:05:52.985Z",
      modifiedAt: "2025-09-10T14:05:52.985Z",
      createdBy: 0,
      modifiedBy: 0,
      createdByName: "",
      modifiedByName: "",
      entityId: 0,
      entityOperationId: 0,
      deptRoleId: 0,
      hospitalId: 0,
      branchId: 0,
      fromStoreBranchId: 0,
      toStoreBranchId: 0,
      isEntitySMS: 0,
      organizationName: "",
      organizationId: 0,
      branchName: "",
      fromStoreBranchName: "",
      toStoreBranchName: "",
      storeName: "",
      fromStoreName: "",
      toStoreName: "",
      supplierName: "",
      rowNumber: 0,
      id: 0,
      maintanenceId: 0,
      itemId: 0,
      barcode: "",
      barcodeNo: 0,
      updatedAt: "2025-09-10T14:05:52.985Z",
      updatedBy: "",
    });
    const copysparesForm = JSON.parse(JSON.stringify(sparesForm.value));
    const escalationForm = ref({
      isNew: true,
      isModified: true,
      isDeleted: true,
      isActive: true,
      createdAt: "2025-09-17T06:58:07.182Z",
      modifiedAt: "2025-09-17T06:58:07.182Z",
      createdBy: 0,
      modifiedBy: 0,
      createdByName: "",
      modifiedByName: "",
      entityId: 0,
      entityOperationId: 0,
      deptRoleId: 0,
      hospitalId: 0,
      branchId: 0,
      fromStoreBranchId: 0,
      toStoreBranchId: 0,
      isEntitySMS: 0,
      organizationName: "",
      organizationId: 0,
      branchName: "",
      fromStoreBranchName: "",
      toStoreBranchName: "",
      storeName: "",
      fromStoreName: "",
      toStoreName: "",
      supplierName: "",
      rowNumber: 0,
      taskStatus: 0,
      taskExpiryDate: "2025-09-17T06:58:07.182Z",
      taskName: "",
      taskPriority: 0,
      responseTimeInHours: 0,
      isApprovalRequired: true,
      levelsOfApproval: 0,
      id: 0,
      maintanenceId: 0,
      escalationDate: "2025-09-17T06:58:07.182Z",
      reason: "",
      currentStatus: 0,
      assignedTo: 0,
      actionTaken: "",
      updatedBy: 0,
      updatedAt: "2025-09-17T06:58:07.182Z",
      reassign: false,
    });
    const copyescalationForm = JSON.parse(JSON.stringify(escalationForm.value));

    watch(
      () => props.trigger,
      async (newval) => {
        if (newval) {
          console.log("Asset changed:", newval);

          await LoadIMaintenanceScheduleMaster("", "");
          await LoadUser("", "");

          const pagename = props.sidebarheading;

          if (props.type === "get") {
            await ListMaintenance(props.tableId, pagename);
          }

          console.log(props.tableId);

          if (pagename === "PerformMaintenance") {
            await CheckListMasterList();
          }
        }
      }
    );
    const headers = ref([
      {
        header: t("assetManagement.maintenancedetails.escalation.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("assetManagement.maintenancedetails.escalation.asset"),
        field: "AssetName",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "boldclass text_overflow2",
      },
      {
        header: t(
          "assetManagement.maintenancedetails.escalation.escalationdate"
        ),
        field: "MaintenanceType",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.maintenancedetails.escalation.assignedto"),
        field: "LastMaintenanceDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.maintenancedetails.escalation.reason"),
        field: "NextMaintenanceDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.maintenancedetails.escalation.actiontaken"),
        field: "NextMaintenanceDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.maintenancedetails.escalation.status"),
        field: "Status",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        slot: "status",
        fieldDisplay: "false",
      },
    ]);
    const sparesheaders = ref([
      {
        header: t("assetManagement.maintenancedetails.escalation.sno"),
        field: "sno",
        class: "filterdisplaynone",
      },
      {
        header: t("assetManagement.maintenancedetails.escalation.asset"),
        field: "label",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "boldclass text_overflow2",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        hide: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ]);

    const Historyheaders = ref([
      // {
      //   header: t("assetManagement.maintenancedetails.escalation.sno"),
      //   field: "RowNumber",
      //   class: "filterdisplaynone",
      // },
      {
        header: t("assetManagement.maintenancedetails.escalation.assignedto"),
        field: "TechnicianName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        slot: "TechnicianName",
        fieldDisplay: "false",
      },
      {
        header: t("assetManagement.maintenancedetails.escalation.createat"),
        field: "CreatedAt",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.maintenancedetails.escalation.status"),
        field: "Status",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        slot: "Status",
        fieldDisplay: "false",
      },
    ]);
    const globalFilterFields = ref(headers.value.map((col) => col.field));
    const globalSparesFilterFields = ref(
      sparesheaders.value.map((col) => col.field)
    );
    const sparesfilters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      label: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: assetSparesList,
      },
    };
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      assetName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: escalationTableList,
      },
      maintenanceType: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: escalationTableList,
      },
      lastMaintenance: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: escalationTableList,
      },
      nextMaintenance: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: escalationTableList,
      },
      status: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: escalationTableList,
      },
      warranty: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: escalationTableList,
      },
    };
    // Methods
    const closedetailsrightsidebar = () => {
      emit("closedetailsrightsidebar");
      Object.assign(scheduleForm.value, copyscheduleForm);
      Object.assign(adhocForm.value, copyadhocForm);
      Object.assign(assignForm.value, copyassignForm);
      Object.assign(escalationForm.value, copyescalationForm);
      Object.assign(checkListMappingForm.value, copycheckListMappingForm);
    };

    const extendSidebar = () => {
      escalationList(props.tableId);
      LoadreasonList();
      isExtended.value = true;
      sidebarwidth.value = "70rem";
      // escalationForm.value.assignedTo =
      //   assetListMaintenanceList.value.RecentMaintenanceLog[0].TechnicianId;
    };

    const collapseSidebar = () => {
      isExtended.value = false;
      sidebarwidth.value = "35rem";
    };

    //Load Item Autocomplete
    async function LoadAsset(assetName, pagename) {
      try {
        if (assetName.length >= 3) {
          const data_response: any =
            await AssetMasterService.getAssetIdbyAutoComplete(
              assetName,
              usersData.HospitalId,
              usersData.BranchId,
              ParamValues.value.StoreId
            );
          console.log(data_response);
          // Check if result exists and is an array
          if (
            data_response &&
            data_response.result &&
            Array.isArray(data_response.result)
          ) {
            assetList.value = data_response.result
              // .filter((item) => item.StatusID == 1)
              .map((item) => {
                return {
                  label:
                    item.AssetName +
                    " | " +
                    item.AssetDisplayId +
                    " | " +
                    item.BarCode,
                  // value: item.Id
                  value: item.AssetId,
                  barcodeNo: item.BarCodeNo,
                  barCode: item.BarCode,
                };
              });
          }
        }
      } catch (error) {
        console.log(error);
        assetList.value = [];
      }
    }
    //Get Asset Details by AssetId
    async function LoadAssetbyId(assetId, pagename) {
      debugger;
      try {
        const data_response: any =
          await AssetMasterService.getItemDetailsByAssetId(assetId);

        console.log(data_response);

        const assetIdList = data_response.result.asset[0];
        const assetName = assetIdList.ItemName + " | " + assetIdList.Barcode;

        if (pagename == "Schedule" && assetName !== "") {
          scheduleForm.value.assetName = assetName;
          scheduleForm.value.assetID = assetIdList.AssetId;
        } else if (pagename == "Assign" && assetName !== "") {
          assignForm.value.assetName = assetName;
          assignForm.value.assetID = assetIdList.AssetId;
        } else if (pagename == "StartAdhoc" && assetName !== "") {
          console.log(assetList.value);
          adhocForm.value.assetName = assetName;
          adhocForm.value.assetID = assetIdList.AssetId;
        }
      } catch (error) {
        console.log(error);
        assetList.value = [];
      }
    }
    async function LoadAssetMaintenanceHistory(assetId) {
      debugger;
      try {
        const data_response: any =
          await AssetMaintenanceService.getListMaintenanceActivityHistory(
            assetId
          );
        let count = 0;
        assetMaintenanceHistory.value = data_response.result.map((item) => {
          count = count + 1;
          item.RowNumber = count;
          return item;
        });
        console.log(data_response);
      } catch (error) {
        console.log(error);
        assetMaintenanceHistory.value = [];
      }
    }

    async function LoadUser(technician, pagename) {
      debugger;
      try {
        const data_response = await StoreService.ListUserByStoreId(
          ParamValues.value.StoreId,
          usersData.HospitalId
        );
        console.log(data_response);

        // Check if result exists and is an array
        if (
          data_response &&
          data_response.result &&
          Array.isArray(data_response.result)
        ) {
          technicianList.value = (
            technician !== ""
              ? data_response.result.filter((item) => item.ID == technician)
              : data_response.result
          ).map((item) => {
            return {
              name: item.UserName,
              value: item.ID,
            };
          });
          if (
            pagename == "Schedule" &&
            technician !== "" &&
            technicianList.value.length > 0
          ) {
            scheduleForm.value.performedBy = technicianList.value[0].value;
          } else if (
            pagename == "Assign" &&
            technician !== "" &&
            technicianList.value.length > 0
          ) {
            assignForm.value.performedBy = technicianList.value[0].value;
          }
        } else {
          console.warn(
            "LoadUser: Invalid response or result is not an array",
            data_response
          );
          technicianList.value = [];
        }
      } catch (error) {
        console.log(error);
        technicianList.value = [];
      }
    }
    async function LoadIMaintenanceScheduleMaster(maintenanceType, pagename) {
      try {
        const response = await MaintenanceScheduleMasterServices.getdata();

        // Check if result exists and is an array
        if (response && response.result && Array.isArray(response.result)) {
          maintenanceTypeList.value = (
            maintenanceType !== ""
              ? response.result.filter((item) => item.Id == maintenanceType)
              : response.result
          ).map((item) => {
            return {
              name: item.MaintenanceType,
              value: item.Id,
            };
          });

          if (
            pagename == "Schedule" &&
            maintenanceType !== "" &&
            maintenanceTypeList.value.length > 0
          ) {
            scheduleForm.value.maintenanceType =
              maintenanceTypeList.value[0].value;
          } else if (
            pagename == "Assign" &&
            maintenanceType !== "" &&
            maintenanceTypeList.value.length > 0
          ) {
            assignForm.value.maintenanceType =
              maintenanceTypeList.value[0].value;
          } else if (pagename == "StartAdhoc") {
            adhocForm.value.maintenanceType = assignForm.value.maintenanceType;
          }
        } else {
          maintenanceTypeList.value = [];
        }
      } catch (error) {
        console.log(error);
        maintenanceTypeList.value = [];
      }
    }
    async function LoadreasonList() {
      try {
        const response = await stockReasonService.getlistdata();

        if (response && response.result) {
          reasonList.value = response.result.map((item) => {
            return {
              name: item.ReasonName,
              value: item.Id,
            };
          });
        } else {
          reasonList.value = [];
        }
      } catch (error) {
        console.log(error);
        reasonList.value = [];
      }
    }

    // async function LoadAssetItem(data) {
    //   try {
    //     const dataresponse = await Itemservice.GetItemByStoresId(
    //       ParamValues.value.StoreId,
    //       0,
    //       data,
    //       0,
    //       0,
    //       0,
    //       0,
    //       usersData.OrganizationId
    //     );

    //     assetItemList.value = dataresponse["result"].map((item: any) => {
    //       item.label =
    //         item.Name +
    //         " |" +
    //         " Qty: " +
    //         item.StockInHand +
    //         " |" +
    //         "Stock Value:" +
    //         item.TotalValue;
    //       item.value = item["" + valueChk + ""];
    //       item.extraValue = item.ItemQuantity; // Set the extraValue attribute to ItemQuantity
    //       if (Type == 0) {
    //         item.BarCodeNo = 0;
    //       }
    //       return item;
    //     })
    //   } catch (error) {
    //     console.log(error)
    //   }
    // }
    async function ListMaintenance(tableId, pagename) {
      debugger;
      console.log(pagename);
      try {
        const response =
          pagename === "StartAdhoc"
            ? fetchStartAdhocDataByID(tableId, pagename)
            : await AssetMaintenanceService.getListMaintenance(tableId);
        console.log(response);
        if (response && response.result) {
          assetListMaintenanceList.value = response.result;

          // Check if required data exists before proceeding
          if (
            assetListMaintenanceList.value.MaintenanceDetails &&
            assetListMaintenanceList.value.MaintenanceDetails.length > 0 &&
            assetListMaintenanceList.value.RecentMaintenanceLog &&
            assetListMaintenanceList.value.RecentMaintenanceLog.length > 0
          ) {
            const assetName =
              assetListMaintenanceList.value.MaintenanceDetails[0].AssetName;
            const assetId =
              assetListMaintenanceList.value.MaintenanceDetails[0].AssetID;
            const maintenanceType =
              assetListMaintenanceList.value.MaintenanceDetails[0]
                .MaintenanceType;
            const technician =
              assetListMaintenanceList.value.RecentMaintenanceLog[0]
                .TechnicianName;
            scheduleForm.value.lastMaintenance =
              assetListMaintenanceList.value.MaintenanceDetails[0].lastMaintenance;
            scheduleForm.value.nextMaintenanceDate =
              assetListMaintenanceList.value.MaintenanceDetails[0].NextMaintenanceDate;
            assignForm.value.scheduledDate =
              assetListMaintenanceList.value.MaintenanceDetails[0].NextMaintenanceDate;
            if (pagename == "PerformMaintenance") {
              performMaintenanceForm.value.scheduledDate =
                assetListMaintenanceList.value.MaintenanceDetails[0].NextMaintenanceDate;
              performMaintenanceForm.value.maintenanceType = maintenanceType;
              performMaintenanceForm.value.performedBy =
                assetListMaintenanceList.value.RecentMaintenanceLog[0].TechnicianId;
              performMaintenanceForm.value.assetID =
                assetListMaintenanceList.value.MaintenanceDetails[0].AssetID;
              performMaintenanceForm.value.assetName =
                assetListMaintenanceList.value.MaintenanceDetails[0].AssetName;
            }

            await LoadAssetbyId(assetId, pagename);
            await LoadIMaintenanceScheduleMaster(maintenanceType, pagename);
            console.log(technician, pagename);
            await LoadUser("", pagename);
            await LoadAssetMaintenanceHistory(tableId);
          } else {
            console.warn(
              "ListMaintenance: Missing required data in response",
              response
            );
          }
        } else {
          console.warn("ListMaintenance: Invalid response", response);
        }
      } catch (error) {
        console.log("ListMaintenance error:", error);
      }
    }
    const saveAdhoc = async () => {
      const results = await validate();
      if (results.valid) {
        try {
          adhocLoading.value = true;
          let response: any;
          let message = "";

          // adhocForm.value.assetID = Number(adhocForm.value.assetID);
          adhocForm.value.assetName = String(adhocForm.value.assetName);
          adhocForm.value.notes = String(adhocForm.value.notes);
          adhocForm.value.createdAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          adhocForm.value.updatedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          adhocForm.value.priority = Number(adhocForm.value.priority);
          adhocForm.value.createdBy = usersData.UserId;
          adhocForm.value.scheduledDate = moment(
            adhocForm.value.scheduledDate,
            "DD-MM-YY"
          ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
          adhocForm.value.performedBy = String(adhocForm.value.performedBy);
          adhocForm.value.cost = Number(adhocForm.value.cost);
          adhocForm.value.maintenanceType = String(
            adhocForm.value.maintenanceType
          );
          adhocForm.value.status = 2;
          console.log(adhocForm.value);

          if (adhocForm.value.id) {
            response = await AssetMaintenanceService.updateSchedule(
              adhocForm.value
            );
          } else {
            response = await AssetMaintenanceService.createdata(
              adhocForm.value
            );
          }

          message = response["ErrorInfo"].ErrorCode;
          if (response["result"] == "Already" && message == null) {
            adhocLoading.value = false;
            alreadyexistpop.value = true;
          } else if (message == null && response["result"] != "Already") {
            if (adhocForm.value.id) {
              updatepop.value = true;
            } else {
              createpop.value = true;
            }
            scheduleLoading.value = false;
          }
        } catch (error) {
          console.log(error);
        }
      }
    };

    const saveMaintenanceSchedule = async () => {
      // Run validation on all fields
      const results = await validate();
      if (results.valid) {
        try {
          scheduleLoading.value = true;
          let response: any;
          let message = "";

          scheduleForm.value.createdAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          scheduleForm.value.modifiedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          scheduleForm.value.branchId = Number(usersData.BranchId);
          scheduleForm.value.hospitalId = Number(usersData.OrganizationId);
          scheduleForm.value.modifiedBy = Number(usersData.UserId);
          scheduleForm.value.createdBy = Number(usersData.UserId);
          scheduleForm.value.updatedBy = String(usersData.UserId);
          scheduleForm.value.lastMaintenance = moment(
            scheduleForm.value.lastMaintenance,
            "DD-MM-YY"
          ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
          scheduleForm.value.nextMaintenanceDate = moment(
            scheduleForm.value.nextMaintenanceDate,
            "DD-MM-YY"
          ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
          scheduleForm.value.entityId = 0;
          scheduleForm.value.organizationId = Number(usersData.OrganizationId);
          scheduleForm.value.maintenanceType = String(
            scheduleForm.value.maintenanceType
          );
          scheduleForm.value.performedBy = String(
            scheduleForm.value.performedBy
          );
          scheduleForm.value.Id = props.tableId;

          response = await AssetMaintenanceService.updateSchedule(
            scheduleForm.value
          );
          message = response["ErrorInfo"].ErrorCode;
          if (response["result"] == "Already" && message == null) {
            scheduleLoading.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            scheduleLoading.value = false;
            updatepop.value = true;
          }
        } catch (error) {}
      }
    };
    const assignTechnician = async () => {
      // Run validation on all fields
      const results = await validate();
      if (results.valid) {
        try {
          assignLoading.value = true;
          let response: any;
          let message = "";

          assignForm.value.createdAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          assignForm.value.modifiedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          assignForm.value.branchId = Number(usersData.BranchId);
          assignForm.value.hospitalId = Number(usersData.OrganizationId);
          assignForm.value.modifiedBy = Number(usersData.UserId);
          assignForm.value.createdBy = Number(usersData.UserId);
          assignForm.value.updatedBy = String(usersData.UserId);
          assignForm.value.scheduledDate = moment(
            assignForm.value.scheduledDate,
            "DD-MM-YY"
          ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
          assignForm.value.entityId = 0;
          assignForm.value.organizationId = Number(usersData.OrganizationId);
          assignForm.value.maintenanceType = String(
            assignForm.value.maintenanceType
          );
          assignForm.value.performedBy = String(assignForm.value.performedBy);
          assignForm.value.Id = props.tableId;

          response = await AssetMaintenanceService.updateAssign(
            assignForm.value
          );
          message = response["ErrorInfo"].ErrorCode;
          if (response["result"] == "Already" && message == null) {
            assignLoading.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            assignLoading.value = false;
            updatepop.value = true;
          }
        } catch (error) {}
      }
    };
    const performMaintenance = async () => {
      // Run validation on all fields
      const results = await validate();
      if (results.valid) {
        try {
          performMaintenanceLoading.value = true;
          let response: any;
          let message = "";

          performMaintenanceForm.value.createdAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          performMaintenanceForm.value.modifiedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          performMaintenanceForm.value.branchId = Number(usersData.BranchId);
          performMaintenanceForm.value.hospitalId = Number(
            usersData.OrganizationId
          );
          performMaintenanceForm.value.modifiedBy = Number(usersData.UserId);
          performMaintenanceForm.value.createdBy = Number(usersData.UserId);
          performMaintenanceForm.value.updatedBy = String(usersData.UserId);
          performMaintenanceForm.value.scheduledDate = moment(
            performMaintenanceForm.value.scheduledDate,
            "DD-MM-YY"
          ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
          performMaintenanceForm.value.entityId = 0;
          performMaintenanceForm.value.organizationId = Number(
            usersData.OrganizationId
          );
          performMaintenanceForm.value.maintenanceType = String(
            performMaintenanceForm.value.maintenanceType
          );
          performMaintenanceForm.value.performedBy = String(
            performMaintenanceForm.value.performedBy
          );
          performMaintenanceForm.value.Id = props.tableId;
          performMaintenanceForm.value.spares = assetSparesList.value;
          response = await AssetMaintenanceService.updatePerformMaintenance(
            performMaintenanceForm.value
          );

          message = response["ErrorInfo"].ErrorCode;
          if (response["result"] == "Already" && message == null) {
            performMaintenanceLoading.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            const checkListMappingresult = await checkListMapping(
              performMaintenanceForm.value.checkList,
              performMaintenanceForm.value.Id
            );
            const sparesMappingresult = await sparesMapping(
              performMaintenanceForm.value.spares,
              performMaintenanceForm.value.Id
            );
            if (checkListMappingresult && sparesMappingresult) {
              performMaintenanceLoading.value = false;
              updatepop.value = true;
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
    const checkListMapping = async (checkList, maintanenceId) => {
      try {
        const checkListMappingArray = checkList.map((id) => {
          return {
            ...checkListMappingForm.value,
            createdAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            modifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            branchId: Number(usersData.BranchId),
            hospitalId: Number(usersData.OrganizationId),
            modifiedBy: Number(usersData.UserId),
            createdBy: Number(usersData.UserId),
            updatedBy: Number(usersData.UserId),
            entityId: 0,
            organizationId: Number(usersData.OrganizationId),
            maintanenceId: maintanenceId,
            checkListId: id,
            id: 0,
          };
        });

        const response = await AssetMaintenanceService.createCheckListMapping(
          checkListMappingArray
        );

        const message = response["ErrorInfo"].ErrorCode;
        if (response["result"] == "Already" && message == null) {
          performMaintenanceLoading.value = false;
          alreadyexistpop.value = true;
        } else if (message == null) {
          return true;
        }
      } catch (error) {
        console.log(error);
      }
    };
    const sparesMapping = async (checkList, maintanenceId) => {
      try {
        const sparesMappingArray = checkList.map((item) => {
          return {
            ...sparesForm.value,
            createdAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            modifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            branchId: Number(usersData.BranchId),
            hospitalId: Number(usersData.OrganizationId),
            modifiedBy: Number(usersData.UserId),
            createdBy: Number(usersData.UserId),
            updatedBy: Number(usersData.UserId),
            entityId: 0,
            organizationId: Number(usersData.OrganizationId),
            maintanenceId: maintanenceId,
            id: 0,
            maintanenceId: maintanenceId,
            itemId: item.value,
            barcode: item.barCode,
            barcodeNo: item.barcodeNo,
            updatedAt: "2025-09-10T14:05:52.985Z",
          };
        });

        const response = await AssetMaintenanceService.createSparePartMapping(
          sparesMappingArray
        );

        const message = response["ErrorInfo"].ErrorCode;
        if (response["result"] == "Already" && message == null) {
          performMaintenanceLoading.value = false;
          alreadyexistpop.value = true;
        } else if (message == null) {
          return true;
        }
      } catch (error) {
        console.log(error);
      }
    };
    const escalationSave = async () => {
      // Run validation on all fields
      const results = await validate();
      if (results.valid) {
        try {
          escalationLoading.value = true;
          let response: any;
          let message = "";

          escalationForm.value.createdAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          escalationForm.value.modifiedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          escalationForm.value.branchId = Number(usersData.BranchId);
          escalationForm.value.hospitalId = Number(usersData.OrganizationId);
          escalationForm.value.modifiedBy = Number(usersData.UserId);
          escalationForm.value.createdBy = Number(usersData.UserId);
          escalationForm.value.updatedBy = String(usersData.UserId);
          escalationForm.value.escalationDate = moment(
            escalationForm.value.escalationDate,
            "DD-MM-YY"
          ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
          escalationForm.value.entityId = 0;
          escalationForm.value.organizationId = Number(
            usersData.OrganizationId
          );
          escalationForm.value.maintanenceId = props.tableId;
          escalationForm.value.reason = String(escalationForm.value.reason);
          escalationForm.value.updatedBy = Number(
            escalationForm.value.updatedBy
          );

          response = await EscalationService.createdata(escalationForm.value);
          message = response["ErrorInfo"].ErrorCode;
          if (response["result"] == "Already" && message == null) {
            escalationLoading.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            toast.add({
              severity: "success",
              summary: "Escalation Completed",
              detail: "",
              life: 3000,
            });
            closedetailsrightsidebar();
            return true;
          }
        } catch (error) {}
      }
    };
    function assetNameAssign(data) {
      console.log("data", data);

      adhocForm.value.assetID = data.value.value;
    }

    async function fetchStartAdhocDataByID(tableId, pagename) {
      const response: any = await AssetMaintenanceService.getfindonedata(
        tableId
      );
      if (response && response.result) {
        adhocForm.value.assetID = response.result.AssetID;
        adhocForm.value.assetName = String(adhocForm.value.assetName);
        adhocForm.value.notes = response.result.Notes;
        adhocForm.value.priority = response.result.Priority;
        adhocForm.value.maintenanceType = Number(
          response.result.MaintenanceType
        );
        adhocForm.value.createdBy = response.result.CreatedBy;
        adhocForm.value.scheduledDate = response.result.ScheduledDate;
        adhocForm.value.performedBy = Number(response.result.PerformedBy);
        adhocForm.value.cost = response.result.Cost;
        adhocForm.value.status = response.result.Status;
        adhocForm.value.id = response.result.Id;
        await LoadAssetbyId(response.result.AssetID, pagename);
      }
    }

    function closetrigger() {
      closedetailsrightsidebar();
      updatepop.value = false;
      createpop.value = false;
    }

    function alreadyclosetrigger() {
      closedetailsrightsidebar();
      alreadyexistpop.value = false;
    }
    const CheckListMasterList = async () => {
      try {
        const response = await CheckListMasterService.getdata();
        if (response && response.result) {
          checklistArray.value = response.result;
        }
      } catch (error) {
        console.log(error);
      }
    };
    const escalationList = async (maintenanceId) => {
      try {
        const response = await EscalationService.getEscalationByMaintanenceId(
          maintenanceId
        );
        if (response && response.result) {
          escalationTableList.value = response.result;
        }
      } catch (error) {
        console.log(error);
      }
    };
    const addSpares = (selected) => {
      if (!selected) return;

      // Check if already exists
      const exists = assetSparesList.value.some(
        (item) => item.value === selected.value.value
      );
      if (!exists) {
        // assetSparesList.value.push(selected.value);
        assetSparesList.value.push({
          ...selected.value,
          sno: assetSparesList.value.length + 1, // assign serial number manually
        });
      } else {
        alert("This spare is already added!");
      }

      // Clear autocomplete value after selection
      performMaintenanceForm.value.spares = null;
    };

    const removeSpare = (index) => {
      assetSparesList.value.splice(index, 1);
    };
    return {
      t,
      sidebarwidth,
      scheduleLoading,
      escalationLoading,
      assignLoading,
      assignForm,
      assetList,
      maintenanceTypeList,
      technicianList,
      priorityList,
      closedetailsrightsidebar,
      saveMaintenanceSchedule,
      saveAdhoc,
      assignTechnician,
      ParamValues,
      assetListMaintenanceList,
      LoadAsset,
      LoadUser,
      LoadIMaintenanceScheduleMaster,
      ListMaintenance,
      AssetIdDisable,
      AssetName,
      scheduleForm,
      closetrigger,
      alreadyclosetrigger,
      alreadyexistpop,
      updatepop,
      checklistArray,
      CheckListMasterList,
      testdata,
      performMaintenanceForm,
      performMaintenanceLoading,
      performMaintenance,
      isExtended,
      extendSidebar,
      collapseSidebar,
      skeletonloading,
      escalationTableList,
      headers,
      filters,
      globalFilterFields,
      escalationForm,
      reasonList,
      createpop,
      escalationSave,
      sparesForm,
      adhocForm,
      assetNameAssign,
      assetItemList,
      assetSparesList,
      sparesheaders,
      sparesfilters,
      globalSparesFilterFields,
      addSpares,
      removeSpare,
      // LoadAssetItem
      loading,
      Historyheaders,
      assetMaintenanceHistory,
    };
  },
});
</script>

<style scoped>
/* Extended sidebar styles */
.sidebar-container {
  display: flex;
  height: 100%;
  /* transition: all 0.3s ease; */
}

.sidebar-container.extended {
  flex-direction: row;
}

.main-content {
  flex: 1;
  overflow-y: auto;
  /* transition: all 0.3s ease; */
}

.main-content.extended {
  flex: 0 0 50%;
  border-right: 1px solid #e9ecef;
  padding-right: 1rem;
}

.extended-content {
  flex: 0 0 50%;
  padding-left: 1rem;
  background-color: #f8f9fa;
  border-left: 1px solid #e9ecef;
  overflow-y: auto;
  animation: slideInRight 0.3s ease;
}

.extended-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 1rem;
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 99;
}
</style>
